const costCenterProjectOwnerName = "/CostCenterProjectOwner";

export function costCenterProjectOwnerService (http) {
    return {
        saveCostCenterProjectOwner: (costCenterType, costCenterProjectOwners, costCenterMKOtherSpecification ) => {
            const costCenterFullDetails = {
                costCenterType,
                costCenterProjectOwners,
                costCenterMKOtherSpecification
            }

            return http.post(costCenterProjectOwnerName + "/SaveNewCostCenterProjectOwner", costCenterFullDetails);
        }
    }
}